import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import CardContainer from '../../components/CardContainer'
import { searchCities, searchCountries } from '../../sources/SearchSource'
import { updateCity, deleteCity, createCity } from '../../sources/AdminSource'
import { translate } from 'react-i18next'
import Grid from 'grid-styled'
import ThemeContainer from '../../components/ThemeContainer'
import AdminNavbar from '../../components/AdminNavbar'
import { Metrics, Fonts, Colors } from '../../Themes'
import BackArrow from '../../svg-icons/BackArrow'
import Edit from '../../svg-icons/Edit'
import Add from '../../svg-icons/Add'
import SearchableDropdown from '../../components/SearchableDropdown'
import UploadPicture from '../../components/UploadPicture'
import TextArea from '../../components/Textarea'
import Input from '../../components/Input'
import SuccessModal from '../../components/Modal/SuccessModal'
import ErrorModal from '../../components/Modal/ErrorModal'
import DialogModal from '../../components/Modal/DialogModal'
import { cityDefault } from '../../Utils/Defaults'

const Container = styled.div`
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};
`

const BackArrowContainer = styled.div`
  margin: ${Metrics.margins.base} 0;
  cursor: pointer;
  span {
    margin-left: ${Metrics.margins.base};
    ${Fonts.style.Header};
  }
`

const Picture = styled.div`
  height: 136px;
  width: 136px;
  background: ${props =>
    props.imageSrc
      ? `url('${props.imageSrc}') no-repeat center`
      : Colors.lightGrey};
  background-size: cover;
  position: relative;
`

const EditIcon = styled.div`
  background: ${Colors.lightGrey};
  width: 40px;
  height: 40px;
  position: absolute;
  cursor: pointer;
  right: -${Metrics.margins.base};
  bottom: -${Metrics.margins.base};
  border-radius: 50%;
  svg {
    margin: 8px;
    #icon-outline {
      fill: ${Colors.white};
    }
  }

  &:hover {
    background: ${Colors.darkGrey};
  }
`

const ImportPicture = styled.div`
  ${Fonts.style.Text};
  color: ${Colors.white};
  margin: 0 auto;
  text-align: center;
  padding: ${Metrics.margins.larger};
  cursor: pointer;

  svg {
    margin: 0 auto;
    margin-bottom: ${Metrics.margins.medium};
    display: block;
    #plus-icon {
      fill: ${Colors.white};
    }
  }
`

const FormTitle = styled.div`
  ${Fonts.style.Label};
  margin-bottom: ${Metrics.margins.small};
`

const CustomGrid = styled(Grid)`
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.small)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.small)};
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding: 0 32px !important; 
`

const Error = styled.div`
  ${Fonts.style.Input};
  margin-top: ${Metrics.margins.tiny};
  color: ${Colors.red};
`

class EditPictures extends Component {
  constructor (props) {
    super(props)
    this.state = {
      city: R.clone(cityDefault),
      countries: [],
      countryName: '',
      imageError: '',
      modal: '',
      create: false
    }
    this.handleUpload = this.handleUpload.bind(this)
    this.handleUpdate = this.handleUpdate.bind(this)
    this.handleDeleteCity = this.handleDeleteCity.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.handleError = this.handleError.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handleSearchCountry = this.handleSearchCountry.bind(this)
  }

  componentWillMount () {
    const { params } = this.props
    if (params.id !== 'new') {
      searchCities({ id: params.id })
        .then(response =>
          this.setState({
            city: response.data,
            countryName: response.data.country.name
          })
        )
        .catch(error => console.log(error))
    } else {
      this.setState({ create: true })
    }
  }

  handleUpload (file, result) {
    const { city } = this.state
    city.picture = { file: file, result: result }
    this.setState({ city, imageError: null })
  }

  handleUpdate () {
    const { city, create } = this.state
    if (create) {
      createCity(city)
        .then(response => {
          let cityCreated = response.data[0] || response.data
          this.setState({ city: cityCreated, modal: 'success' })
        })
        .catch(error => {
          console.log(error)
          this.setState({ modal: 'error' })
        })
    } else {
      updateCity(city)
        .then(response => {
          this.setState({ city: response.data, modal: 'success' })
        })
        .catch(error => {
          console.log(error)
          this.setState({ modal: 'error' })
        })
    }
  }

  handleSearchCountry (event) {
    this.setState({ countryName: event.target.value }, () => {
      searchCountries({
        where: { name: { startsWith: this.state.countryName } }
      })
        .then(response => this.setState({ countries: response.data }))
        .catch(error => console.log(error))
    })
  }

  handleDeleteCity () {
    deleteCity(this.state.city.id)
      .then(response => this.props.router.goBack())
      .catch(error => {
        console.log(error)
        this.setState({ modal: 'error' })
      })
  }

  handleChange (event, key) {
    const { city } = this.state
    if (key === 'lat' || key === 'lng') {
      city.latlng[key] = event.target.value
    } else {
      city[key] = event.target.value
    }
    this.setState({ city })
  }

  handleSelect (el) {
    const { city } = this.state
    city.country = el
    this.setState({ city, countryName: el.name })
  }

  toggleModal (modal) {
    this.setState({ modal })
  }

  handleError () {
    const { t } = this.props
    this.setState({
      imageError: t('Image too large (2MB max) or has an invalid type')
    })
  }

  render () {
    const { t, router, admin, dropdownLinks } = this.props
    const {
      city,
      modal,
      imageError,
      create,
      countryName,
      countries
    } = this.state
    const adminActions = [
      { label: t('Save'), secondary: true, onClick: this.handleUpdate }
    ]
    if (!create) {
      adminActions.push({
        label: t('Delete City'),
        cancel: true,
        onClick: () => this.toggleModal('dialog')
      })
    }
    return (
      <div>
        <AdminNavbar
          admin={admin}
          dropdownLinks={dropdownLinks}
          fixedSearchBar
          rightSideActions={adminActions}
        />
        <SuccessModal
          visible={modal === 'success'}
          message={t(`City successfuly ${create ? 'created' : 'updated'}.`)}
          header={t(`City ${create ? 'Created' : 'Updated'}`)}
          closeAction={this.toggleModal}
        />
        <ErrorModal
          visible={modal === 'error'}
          message={t(
            `There was a problem when ${create
              ? 'creating'
              : 'updating'} the city.`
          )}
          header={t('Error')}
          closeAction={this.toggleModal}
        />
        <DialogModal
          visible={modal === 'dialog'}
          message={t('Do you want to delete this city?')}
          header={t('Delete City')}
          closeAction={this.toggleModal}
          buttons={{
            apply: {
              label: 'Cancel',
              onClick: this.toggleModal
            },
            cancel: {
              label: 'Delete',
              onClick: this.handleDeleteCity
            }
          }}
        />
        <Container>
          {city && (
            <CustomThemeContainer>
              <BackArrowContainer>
                <BackArrow onClick={() => router.goBack()} />
                <span className='name'>
                  {create ? t('Insert City') : city.city}
                </span>
              </BackArrowContainer>
              <CustomCardContainer
                title={create ? t('Create New City') : t('Edit City')}>
                <CustomGrid noPadTop noPadLeft noPadRight>
                  <Input
                    value={city.city}
                    title={t('City')}
                    handleChange={event => this.handleChange(event, 'city')}
                    placeholder={t('City Name')}
                  />
                </CustomGrid>
                <CustomGrid noPadLeft noPadRight>
                  <CustomGrid xs={1 / 3} noPadLeft noPadTop>
                    <FormTitle>{t('Country')}</FormTitle>
                    <SearchableDropdown
                      value={countryName}
                      handleSelect={this.handleSelect}
                      handleSearch={this.handleSearchCountry}
                      placeholder={t('Country name')}
                      options={countries}
                      accessor={d => d.name}
                    />
                  </CustomGrid>
                  <CustomGrid xs={1 / 3} noPadTop>
                    <Input
                      value={`${city.latlng.lat}`}
                      title={t('Latitude')}
                      placeholder={t('Latitude')}
                      handleChange={event => this.handleChange(event, 'lat')}
                    />
                  </CustomGrid>
                  <CustomGrid xs={1 / 3} noPadRight noPadTop>
                    <Input
                      value={`${city.latlng.lng}`}
                      title={t('Longitude')}
                      handleChange={event => this.handleChange(event, 'lng')}
                      placeholder={t('Longitude')}
                    />
                  </CustomGrid>
                  <CustomGrid noPadLeft noPadRight>
                    <TextArea
                      title={t('Description')}
                      value={city.description}
                      handleChange={event =>
                        this.handleChange(event, 'description')}
                      placeholder={t('City description')}
                    />
                  </CustomGrid>
                </CustomGrid>
                <CustomGrid noPadLeft noPadRight>
                  <Picture
                    imageSrc={
                      (city.picture && city.picture.result) || city.picture
                    }>
                    <UploadPicture
                      uploadButton={
                        city.picture ? (
                          <EditIcon>
                            <Edit />
                          </EditIcon>
                        ) : (
                          <ImportPicture>
                            <Add />
                            {t('Import Picture')}
                          </ImportPicture>
                        )
                      }
                      handleError={this.handleError}
                      handleUploaded={this.handleUpload}
                    />
                  </Picture>
                  {imageError && <Error>{imageError}</Error>}
                </CustomGrid>
              </CustomCardContainer>
            </CustomThemeContainer>
          )}
        </Container>
      </div>
    )
  }
}

EditPictures.propTypes = {
  router: PropTypes.object,
  params: PropTypes.object,
  t: PropTypes.func,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin' ], { wait: true })(EditPictures)



// WEBPACK FOOTER //
// ./src/pages/AdminLocations/EditCity.js